import React, { useEffect, useState } from 'react';

function GroupEmailReservation({ onChangeSegments }) {
    // 초기 구간 정보 배열 (구간 1)
    const [segments, setSegments] = useState([{ id: 1, email: '' }]);

    useEffect(() => {
        onChangeSegments(segments);
    }, [segments, onChangeSegments]);

    // 구간 추가 버튼 클릭 시 새로운 구간을 배열에 추가
    const handleAddSegment = () => {
        setSegments([
            ...segments,
            {
                id: segments.length + 1,
                email: '',
            },
        ]);
    };

    // 각 구간의 값 변경 처리 (필요에 따라 확장 가능)
    const handleChange = (id, field, value) => {
        setSegments(
            segments.map((segment) =>
                segment.id === id ? { ...segment, [field]: value } : segment,
            ),
        );
    };

    return (
        <>
            {segments.map((segment, index) => (
                <td className='input-button wpal-group-input-button' key={segment.id}>
                    <div className='table-padding'>
                        <input
                            type='text'
                            id='userEmail'
                            placeholder='이메일'
                            value={segment.email}
                            onChange={(e) => handleChange(segment.id, 'email', e.target.value)}
                        />
                    </div>
                    {index === segments.length - 1 && (
                        <div className='group-reservation wpal-route-add-wrap'>
                            <button
                                className='each-button wpal-group-each-button'
                                onClick={handleAddSegment}
                            >
                                + 이메일 주소 추가
                            </button>
                            {segments.length > 1 ? (
                                <button
                                    className='wpal-routeRemove-email'
                                    onClick={() => {
                                        setSegments(
                                            segments.filter((seg) => seg.id !== segment.id),
                                        );
                                    }}
                                >
                                    - 삭제
                                </button>
                            ) : (
                                <></>
                            )}
                        </div>
                    )}
                </td>
            ))}
        </>
    );
}

export default GroupEmailReservation;
